import { Component } from '@angular/core';
import {AppConfigService} from '../../services/config/app-config.service';
import {TokenStorageService} from '../../services/storage/token-storage.service';
import {environment} from "../../../environments/environment";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-generate-keys',
    templateUrl: './generate-keys.component.html',
    styleUrl: './generate-keys.component.css',
    standalone: false
})
export class GenerateKeysComponent {
  projectId: string | undefined;

  userType: string | undefined;
  iframeUrl: SafeResourceUrl | null = null;
  private iframeRef: HTMLIFrameElement | null = null;
  private targetOrigin = '';

  constructor(private appConfig: AppConfigService, tokenStorageService: TokenStorageService, private sanitizer: DomSanitizer) {
    try {
      console.log(tokenStorageService.getUserEnv())
      this.userType = (window.location.hostname == this.appConfig.priceDomain) ? "FEED" : (window.location.hostname == this.appConfig.tradeDomain) ? "OMS" : "";

      if (this.userType == 'OMS') {
        if (tokenStorageService.getUserEnv() == 'asia') {
          this.projectId = appConfig.getAsiaConfig?.omsProjectId;
        } else {
          this.projectId = appConfig.getMenaConfig?.omsProjectId;
        }
      } else {
        this.projectId = appConfig.getCommonConfig?.feedProjectId;
      }

    } catch (error) {
      console.log(error);
    }

  }

  ngOnInit(): void {
    const queryParams = window.location.search;
    const keyGenAppUrl = environment.keyGenAppUrl;

    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${keyGenAppUrl}${queryParams}`
    );

    // Wait until DOM is ready
    setTimeout(() => {
      this.iframeRef = document.getElementById('keygen-iframe') as HTMLIFrameElement;
      if (!this.iframeRef) {
        console.error('Iframe element not found.');
        return;
      }

      // Attach load listener BEFORE sending message
      this.iframeRef.addEventListener('load', () => {
        console.log('Iframe loaded, sending parent URL...');
        this.postParentUrl();
      });
    });
  }

  private postParentUrl(): void {
    if (!this.iframeRef?.contentWindow) {
      console.warn('Iframe not ready to receive postMessage.');
      return;
    }

    const parentUrl = window.location.href;
    console.log('Sending parent URL to iframe:', parentUrl);

    this.iframeRef.contentWindow.postMessage(
      { parentUrl },
      this.targetOrigin
    );
  }

  ngOnDestroy(): void {
    // Clean up listener (good practice)
    if (this.iframeRef) {
      this.iframeRef.removeEventListener('load', this.postParentUrl);
    }
  }
}
